import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

const { REACT_APP_ENV_IS_DEVLOPMENT, REACT_APP_ENV_IS_STAGING } = process.env;

//query client instance
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

/**
 * Provider Component
 *
 * React Query setup
 *
 * @export
 * @param {*} {children}
 * @return {*}
 */
export default function ReactQueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient} contextSharing>
      {children}

      {(REACT_APP_ENV_IS_DEVLOPMENT || REACT_APP_ENV_IS_STAGING) && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}
